module.exports = __webpack_public_path__ + "static/media/my-clinic-ic.9c6c7b28.svg";